import React, {useState, useEffect, useCallback} from "react";
import {OrderSummaryWrap, OrderChart, ProgressBar} from "./Dashboard.styles";
import {MdOutlineKeyboardArrowRight} from "react-icons/md";
import {PieChart} from "@mui/x-charts";
import {useSelector} from "react-redux";
import analyticsService from "services/analyticsService";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "Context/authContext";

const OrderSummary = ({selectedPeriod, customDateRange, currentStoreId}) => {
    const navigate = useNavigate();
    const userState = useSelector(state => state.business.user);
    const { user } = useAuthContext();
    const finalUser = user || userState;
    const business = useSelector(state => state.business.businessId);
    console.log('business', business);
    const businessIdFromAuth = finalUser?.businessId;
    const businessId = businessIdFromAuth || business;
    const [ordersSummary, setOrdersSummary] = useState({
        counts: {
            onDelivery: 0,
            delivered: 0,
            cancelled: 0,
            pickup: 0,
            newOrders: 0
        },
        percentages: {
            onDelivery: 0,
            delivered: 0,
            cancelled: 0,
            pickup: 0
        },
        total: 0
    });
    const [loading, setLoading] = useState(false);

    const getOrdersSummary = useCallback(async () => {
        try {
            setLoading(true);
            // Simplified businessId logic
            const restaurantId = businessId || (Array.isArray(finalUser?.businessId) ? finalUser.businessId[0] : null);
            
            if (!restaurantId) {
                console.warn('📊 OrderSummary: No restaurant ID available');
                setLoading(false);
                return;
            }
            
            const params = {
                restaurantId,
            };
            
            // Add storeId if available
            if (currentStoreId) {
                params.storeId = currentStoreId;
            }
            
            // Add time period filters
            if (selectedPeriod) {
                params.period = selectedPeriod;
            }
            
            // Add custom date range if selected
            if (selectedPeriod === 'custom') {
                if (customDateRange?.startDate) {
                    params.startDate = customDateRange.startDate;
                }
                if (customDateRange?.endDate) {
                    params.endDate = customDateRange.endDate;
                }
            }            
            const res = await analyticsService.getOrdersSummary(params);
            console.log('📊 OrderSummary: API response:', res);
            
            if (res?.success && res?.data) {
                setOrdersSummary(res.data);
            }
        } catch (error) {
            console.error('📊 OrderSummary: Error fetching orders summary:', error);
            // Keep default values on error
        } finally {
            setLoading(false);
        }
    }, [businessId, finalUser, currentStoreId, selectedPeriod, customDateRange]);

    useEffect(() => {
        if (currentStoreId && (businessId || finalUser?.businessId?.[0])) {
            getOrdersSummary();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStoreId, selectedPeriod, customDateRange]);

    const chartData = [
        {label: "On Delivery", value: ordersSummary.counts.onDelivery, color: "#22B573"},
        {label: "Delivered", value: ordersSummary.counts.delivered, color: "#27C453"},
        {label: "Cancelled", value: ordersSummary.counts.cancelled, color: "#E21D25"},
        {label: "Pickup", value: ordersSummary.counts.pickup, color: "#8527C4"},
    ];

    const statusData = [
        {
            name: "On Delivery",
            count: ordersSummary.counts.onDelivery,
            percentage: ordersSummary.percentages.onDelivery || 0,
            color: "#22B573",
        },
        {
            name: "Delivered",
            count: ordersSummary.counts.delivered,
            percentage: ordersSummary.percentages.delivered || 0,
            color: "#27C453",
        },
        {
            name: "Cancelled",
            count: ordersSummary.counts.cancelled,
            percentage: ordersSummary.percentages.cancelled || 0,
            color: "#E21D25",
        },
        {
            name: "Pickup",
            count: ordersSummary.counts.pickup,
            percentage: ordersSummary.percentages.pickup || 0,
            color: "#8527C4",
        },
    ];

    const {newOrders} = ordersSummary.counts;

    return (
        <OrderSummaryWrap>
            <div className="header">
                <div className="title">
                    <h2>Orders Summary</h2>
                    <p>Summary of Orders</p>
                </div>
                {/* <div className="summary-tabs">
                    <span
                        onClick={() => setSelectedTab("Monthly")}
                        className={selectedTab === "Monthly" ? "active" : ""}>
                        Monthly
                    </span>
                    <span onClick={() => setSelectedTab("Weekly")} className={selectedTab === "Weekly" ? "active" : ""}>
                        Weekly
                    </span>
                    <span onClick={() => setSelectedTab("Today")} className={selectedTab === "Today" ? "active" : ""}>
                        Today
                    </span>
                </div> */}
            </div>
            <div className="new-orders">
                <span>
                    <strong>{loading ? "..." : newOrders}</strong> New Orders
                </span>
                <div className="manage-order-list" onClick={() => navigate('/live-orders')} style={{cursor: 'pointer'}}>
                    <p>Manage Orders</p>
                    <MdOutlineKeyboardArrowRight />
                </div>
            </div>

            <div className="order-stats">
                {statusData.map((status, index) => (
                    <div className="stat-card" key={index}>
                        <h3>{loading ? "..." : status.count}</h3>
                        <p>{status.name}</p>
                    </div>
                ))}
            </div>
            <OrderChart>
                <div className="chart">
                    <PieChart
                        series={[{innerRadius: 60, outerRadius: 80, data: chartData}]}
                        margin={{right: 5}}
                        width={255}
                        height={255}
                        legend={{hidden: true}}
                    />
                </div>
                <div className="progress-bars">
                    {statusData.map((status, index) => (
                        <ProgressBar key={index} color={status.color}>
                            <div className="label">
                                {status.name} ({status.percentage.toFixed(1)}%)
                            </div>
                            <div className="bar-container">
                                <div className="bar" style={{width: `${status.percentage}%`}} />
                            </div>
                            <span>{status.count}</span>
                        </ProgressBar>
                    ))}
                </div>
            </OrderChart>
        </OrderSummaryWrap>
    );
};

export default OrderSummary;
